import TopNav from './TopNav';

export default function Layout({ onLogout, activePage, onNavigate, onOpenSettings, userId, members, children }) {
  return (
    <div className="min-h-screen" style={{ background: 'var(--bg, #131216)' }}>
      <TopNav onLogout={onLogout} activePage={activePage} onNavigate={onNavigate} onOpenSettings={onOpenSettings} userId={userId} members={members} />
      <main>{children}</main>
    </div>
  );
}
